function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define("YWWriterIconsReact.ChevronDown", ["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React);
    global.YWWriterIconsReact = global.YWWriterIconsReact || {};
    global.YWWriterIconsReact["ChevronDown"] = mod.exports.default;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (exports, React) {
  "use strict";

  var ChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2.31264 7.31267C2.70316 6.92214 3.33633 6.92214 3.72685 7.31267L12 15.5858L20.2731 7.31267C20.6637 6.92214 21.2968 6.92214 21.6874 7.31267C22.0779 7.70319 22.0779 8.33636 21.6874 8.72688L12 18.4142L2.31264 8.72688C1.92211 8.33636 1.92211 7.70319 2.31264 7.31267Z",
    fill: "currentColor"
  }));
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = ChevronDown;
});